var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { registerClass, classNames, defaultTheme, } from '@food/css-manager';
export var CollapsiblePhases;
(function (CollapsiblePhases) {
    CollapsiblePhases[CollapsiblePhases["COLLAPSED"] = 0] = "COLLAPSED";
    CollapsiblePhases[CollapsiblePhases["PRE_EXPANDING"] = 1] = "PRE_EXPANDING";
    CollapsiblePhases[CollapsiblePhases["EXPANDING"] = 2] = "EXPANDING";
    CollapsiblePhases[CollapsiblePhases["EXPANDED"] = 3] = "EXPANDED";
    CollapsiblePhases[CollapsiblePhases["PRE_COLLAPSING"] = 4] = "PRE_COLLAPSING";
    CollapsiblePhases[CollapsiblePhases["COLLAPSING"] = 5] = "COLLAPSING";
})(CollapsiblePhases || (CollapsiblePhases = {}));
// -webkit-transition: min-height ${t.timings.base / 2000}s, opacity ${t.timings.base /
// 	2000}s, max-height ${t.timings.base / 2000}s;
// -moz-transition: min-height ${t.timings.base / 2000}s, opacity ${t.timings.base /
// 	2000}s, max-height ${t.timings.base / 2000}s;
// -ms-transition: min-height ${t.timings.base / 2000}s, opacity ${t.timings.base /
// 	2000}s, max-height ${t.timings.base / 2000}s;
// -o-transition: min-height ${t.timings.base / 2000}s, opacity ${t.timings.base /
// 	2000}s, max-height ${t.timings.base / 2000}s;
var articleContainerStyle = registerClass(function (t) { return "\n\ttransition: min-height " + t.timings.base / 2000 + "s, opacity " + t.timings.base /
    2000 + "s, max-height " + t.timings.base / 2000 + "s;\n\toverflow: hidden;\n\tbox-sizing: content-box !important;\n\t"; });
var fadedOut = registerClass(function () { return "\n\topacity: 0;\n"; });
function CollapsibleBlockFactory(parent, registerBlockRef, unregisterBlockRef) {
    return /** @class */ (function (_super) {
        __extends(CollapsibleBlock, _super);
        function CollapsibleBlock(props) {
            var _this = _super.call(this, props) || this;
            _this.articleContainer = React.createRef();
            return _this;
        }
        CollapsibleBlock.prototype.componentDidMount = function () {
            registerBlockRef(this.articleContainer);
        };
        CollapsibleBlock.prototype.componentWillUnmount = function () {
            unregisterBlockRef(this.articleContainer);
        };
        CollapsibleBlock.prototype.render = function () {
            var _a = this.props, children = _a.children, className = _a.className;
            var phase = parent.state.phase;
            return (React.createElement("div", { ref: this.articleContainer, className: classNames(className, articleContainerStyle, (phase === CollapsiblePhases.PRE_EXPANDING ||
                    phase === CollapsiblePhases.PRE_COLLAPSING) &&
                    fadedOut) }, children));
        };
        return CollapsibleBlock;
    }(React.PureComponent));
}
function getContainerContentHeight(container) {
    // TODO - migliorare per i casi in cui ci sono più children o ci sono margin e simili
    var article = container.firstChild;
    return article ? article.scrollHeight : 0;
}
var Collapsible = /** @class */ (function (_super) {
    __extends(Collapsible, _super);
    function Collapsible(props) {
        var _this = _super.call(this, props) || this;
        var startOpen = props.startOpen;
        _this.articleContainers = [];
        _this.state = {
            phase: startOpen
                ? CollapsiblePhases.EXPANDED
                : CollapsiblePhases.COLLAPSED,
        };
        _this.CollapsibleBlock = CollapsibleBlockFactory(_this, _this.registerBlockRef.bind(_this), _this.unregisterBlockRef.bind(_this));
        return _this;
    }
    Collapsible.prototype.registerBlockRef = function (refCont) {
        if (!this.articleContainers.includes(refCont)) {
            this.articleContainers.push(refCont);
        }
    };
    Collapsible.prototype.unregisterBlockRef = function (refCont) {
        var refIndex = this.articleContainers.indexOf(refCont);
        if (refIndex >= 0) {
            this.articleContainers.splice(refIndex);
        }
    };
    Collapsible.prototype.expand = function () {
        var _this = this;
        if (this.props.forceOpenState !== undefined) {
            return;
        }
        var phase = this.state.phase;
        this.articleContainers.forEach(function (refCont) {
            var container = refCont.current;
            if (!container) {
                return;
            }
            var actualHeight = getContainerContentHeight(container);
            if (phase !== CollapsiblePhases.COLLAPSED) {
                return;
            }
            container.style.removeProperty('min-height');
            container.style.maxHeight = actualHeight + 'px';
        });
        if (phase !== CollapsiblePhases.COLLAPSED) {
            return;
        }
        this.setState({ phase: CollapsiblePhases.PRE_EXPANDING }); // avvio il fade out
        // Annullo l'eventuale transizione in corso
        if (this.transitionTimeout) {
            clearTimeout(this.transitionTimeout);
            this.transitionTimeout = undefined;
        }
        this.transitionTimeout = setTimeout(function () { return _this.setState({ phase: CollapsiblePhases.EXPANDING }); }, defaultTheme.timings.base / 2);
    };
    Collapsible.prototype.collapse = function () {
        var _this = this;
        if (this.props.forceOpenState !== undefined) {
            return;
        }
        var phase = this.state.phase;
        this.articleContainers.forEach(function (refCont) {
            var container = refCont.current;
            if (!container) {
                return;
            }
            var actualHeight = container.scrollHeight;
            if (phase !== CollapsiblePhases.EXPANDED) {
                return;
            }
            container.style.removeProperty('max-height');
            container.style.minHeight = actualHeight + 'px';
        });
        if (phase !== CollapsiblePhases.EXPANDED) {
            return;
        }
        this.setState({ phase: CollapsiblePhases.PRE_COLLAPSING }); // avvio il fade out
        // Annullo l'eventuale transizione in corso
        if (this.transitionTimeout) {
            clearTimeout(this.transitionTimeout);
            this.transitionTimeout = undefined;
        }
        this.transitionTimeout = setTimeout(function () { return _this.setState({ phase: CollapsiblePhases.COLLAPSING }); }, defaultTheme.timings.base / 2);
    };
    Collapsible.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var phase = this.state.phase;
        // Forzatura stato dall'esterno aggiunta o tolta
        if (this.props.forceOpenState !== undefined || prevProps.forceOpenState) {
            var targetPhase = void 0;
            if (this.props.forceOpenState !== undefined) {
                targetPhase = this.props.forceOpenState
                    ? CollapsiblePhases.EXPANDED
                    : CollapsiblePhases.COLLAPSED;
            }
            else {
                targetPhase = this.props.startOpen
                    ? CollapsiblePhases.EXPANDED
                    : CollapsiblePhases.COLLAPSED;
            }
            if (phase !== targetPhase) {
                // Annullo l'eventuale transizione in corso
                if (this.transitionTimeout) {
                    clearTimeout(this.transitionTimeout);
                    this.transitionTimeout = undefined;
                }
                this.articleContainers.forEach(function (refCont) {
                    var container = refCont.current;
                    if (!container) {
                        return;
                    }
                    container.style.removeProperty('min-height');
                    container.style.removeProperty('max-height');
                });
                this.setState({ phase: targetPhase });
            }
        }
        // Fine delle fasi di transizione
        else if (phase === CollapsiblePhases.EXPANDING ||
            phase === CollapsiblePhases.COLLAPSING) {
            this.articleContainers.forEach(function (refCont) {
                var container = refCont.current;
                if (!container) {
                    return;
                }
                var actualHeight = getContainerContentHeight(container);
                if (phase === CollapsiblePhases.EXPANDING) {
                    container.style.removeProperty('min-height');
                    container.style.maxHeight = actualHeight + 'px';
                }
                else if (phase === CollapsiblePhases.COLLAPSING) {
                    container.style.removeProperty('max-height');
                    container.style.minHeight = actualHeight + 'px';
                }
            });
            if (this.transitionTimeout) {
                clearTimeout(this.transitionTimeout);
                this.transitionTimeout = undefined;
            }
            if (phase === CollapsiblePhases.EXPANDING) {
                this.transitionTimeout = setTimeout(function () { return _this.setState({ phase: CollapsiblePhases.EXPANDED }); }, defaultTheme.timings.base / 2);
            }
            else if (phase === CollapsiblePhases.COLLAPSING) {
                this.transitionTimeout = setTimeout(function () { return _this.setState({ phase: CollapsiblePhases.COLLAPSED }); }, defaultTheme.timings.base / 2);
            }
        }
        if (phase === CollapsiblePhases.EXPANDED ||
            phase === CollapsiblePhases.COLLAPSED) {
            // Pulisco la situazione
            if (this.transitionTimeout) {
                clearTimeout(this.transitionTimeout);
                this.transitionTimeout = undefined;
            }
            this.articleContainers.forEach(function (refCont) {
                var container = refCont.current;
                if (!container) {
                    return;
                }
                container.style.removeProperty('min-height');
                container.style.removeProperty('max-height');
            });
        }
    };
    Collapsible.prototype.render = function () {
        var children = this.props.children;
        var phase = this.state.phase;
        var open = phase === CollapsiblePhases.EXPANDING ||
            phase === CollapsiblePhases.PRE_COLLAPSING ||
            phase === CollapsiblePhases.EXPANDED;
        return children({
            phase: phase,
            open: open,
            expand: this.expand.bind(this),
            collapse: this.collapse.bind(this),
            CollapsibleBlockClass: this.CollapsibleBlock,
        });
    };
    return Collapsible;
}(React.PureComponent));
export { Collapsible };
//# sourceMappingURL=Collapsible.js.map